import { z } from 'zod'
import { codePointText } from '~/services/api/contracts/codePointText'
import { MENU_DESCRIPTION_MAX } from '~/services/api/contracts/bounds/MENU_DESCRIPTION_MAX'
import { menuScheduleRules } from '~/services/api/contracts/menuScheduleRules'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdateMenuRequestSchema } from '~/services/api/generated'
import { menuFieldsNormalizer } from '~/services/api/contracts/normalizers/menuFieldsNormalizer'

const schema = UpdateMenuRequestSchema.omit({ store_id: true })
  .extend({ description: codePointText(MENU_DESCRIPTION_MAX).nullish() })
  .strict()

export const MenuUpdate = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(menuFieldsNormalizer, schema).superRefine((value, issues) => {
    menuScheduleRules(value, issues)

    const availableFrom = value.available_from
    const availableUntil = value.available_until
    if (
      typeof availableFrom === 'string' &&
      typeof availableUntil === 'string' &&
      availableUntil <= availableFrom
    ) {
      issues.addIssue({
        code: 'custom',
        message: 'The available until field must be a date after available from',
        path: ['available_until']
      })
    }
  })
